import axios from "axios";
import { validateTokenOnRequest } from "./tokenValidation";
import { getLocalStorageItem } from "./localStorageItems";

const token = getLocalStorageItem("token");
const refreshToken = getLocalStorageItem("refreshToken");
const email = getLocalStorageItem("email");

// const uri = "http://192.168.0.133:"
// const uri = "http://localhost:";
export const uri = "https://backend.elberttech.com";
// export const uri = "https://enscenter.xyz";



const API_URL = {
  base: `${uri}`,
  port8080: `${uri}8080`,
  port8081: `${uri}8081`,
  port8082: `${uri}8082`,
  port8083: `${uri}8083`,
  port8084: `${uri}8084`,
};

export const axiosApi = axios.create({
  baseURL: API_URL["base"],
});

// Set the Authorization header only if the token is available
if (token) {
  axiosApi.defaults.headers.common["Authorization"] = `Bearer ${token}`;
}

if (refreshToken) {
  axiosApi.defaults.headers.common[
    "x-refresh-token"
  ] = `Bearer ${refreshToken}`;
}

if (email) {
  axiosApi.defaults.headers.common["email"] = email;
}

// Avoid setting Access-Control-Allow-Origin here; it's server-side.
axiosApi.defaults.headers.common["Accept"] = "application/json"; // Expecting JSON response
axiosApi.defaults.headers.common["Content-Type"] = "application/json"; // Sending JSON request

export const doPortChange = (port = "port8080") => {
  // axiosApi.defaults["baseURL"] = API_URL[port];
};

axiosApi.interceptors.response.use(
  (response) => response,
  (error) => Promise.reject(error)
);

axiosApi.interceptors.request.use(
  (config) => {
    const token = getLocalStorageItem("token");

    if (token) {
      validateTokenOnRequest();
      config.headers["Authorization"] = `Bearer ${token}`;
    }

    return config;
  },
  (error) => {
    console.error("Request Error:", error);
    return Promise.reject(error);
  }
);

// Adjusted `get` function to avoid sending data in the body for GET requests
export async function get(url, params = {}, config = {}) {
  return await axiosApi
    .get(url, { params, ...config }) // Pass data as query parameters
    .then((response) => response.data);
}

export async function post(url, data, config = {}) {
  return await axiosApi
    .post(url, { ...data }, { ...config })
    .then((response) => response.data);
}

export async function postJsonRaw(url, data, config = {}) {
  return await axiosApi
    .post(url, data, {
      headers: {
        'Content-Type': 'application/json',
        ...config.headers,
      },
      ...config,
    })
    .then((response) => response.data);
}

export async function putJsonRaw(url, data, config = {}) {
  return await axiosApi
    .put(url, data, {
      headers: {
        'Content-Type': 'application/json',
        ...config.headers,
      },
      ...config,
    })
    .then((response) => response.data);
}



export async function postFile(url, formData, config = {}) {
  // Ensure Content-Type is not set to application/json for FormData
  const fileConfig = {
    ...config,
    headers: {
      ...config.headers,
      "Content-Type": undefined, // Let browser set multipart/form-data with boundary
    },
  };

  return await axiosApi
    .post(url, formData, fileConfig) // Pass FormData directly, no wrapping
    .then((response) => response.data);
}

export async function put(url, data, config = {}) {
  return await axiosApi
    .put(url, { ...data }, { ...config })
    .then((response) => response.data);
}

export async function del(url, config = {}) {
  return await axiosApi
    .delete(url, { ...config })
    .then((response) => response.data);
}


